import { SubVertical } from 'common/constants'

export enum ContentType {
  NEWS = 'NEWS',
  SALE_INFO = 'SALE_INFO',
  INTERVIEW = 'INTERVIEW',
  LOOKBOOK = 'LOOKBOOK',
  COLLECTION = 'COLLECTION',
  SHOWROOM = 'SHOWROOM',
  DIARY = 'DIARY',
  SUPPORTERS = 'SUPPORTERS',
  BRAND_NEWS = 'BRAND_NEWS',
  BRAND_LOOKBOOK = 'BRAND_LOOKBOOK',
  VIDEO = 'VIDEO',
  BRAND_EVENT = 'BRAND_EVENT',
  DAILYLOOK = 'DAILYLOOK',
  PET_NEWS = 'PET_NEWS',
  PET_SALE_INFO = 'PET_SALE_INFO',
  FOOD_NEWS = 'FOOD_NEWS',
  FOOD_SALE_INFO = 'FOOD_SALE_INFO',
  FOOD_RECIPE = 'FOOD_RECIPE',
  COOKING_INFO = 'COOKING_INFO',
  FREE_TRIAL = 'FREE_TRIAL',
  BROADCAST = 'BROADCAST',
  COLLABORATION = 'COLLABORATION',
  NONE = 'NONE',
  OUTLET_NOW = 'OUTLET_NOW',
}

type typesUsedInSubVertical = {
  [key in SubVertical]?: {
    contentTypes: ContentType[]
  }
}

export const typesUsedInSubVertical: typesUsedInSubVertical = {
  FASHION_BRAND: {
    contentTypes: [
      ContentType.BRAND_LOOKBOOK,
      ContentType.VIDEO,
      ContentType.BRAND_NEWS,
      ContentType.DAILYLOOK,
      ContentType.BRAND_EVENT,
      ContentType.BROADCAST,
      ContentType.COLLABORATION,
    ],
  },
}

export const getContentTypesName = (contentType: ContentType): string => {
  switch (contentType) {
    case ContentType.BRAND_NEWS:
    case ContentType.PET_NEWS:
    case ContentType.FOOD_NEWS:
      return 'NEWS'
    case ContentType.SALE_INFO:
    case ContentType.PET_SALE_INFO:
    case ContentType.FOOD_SALE_INFO:
      return 'SALE'
    case ContentType.BRAND_EVENT:
      return 'EVENT'
    case ContentType.COOKING_INFO:
      return '요리정보'
    case ContentType.FREE_TRIAL:
      return '무료체험'
    case ContentType.FOOD_RECIPE:
      return '레시피'
    case ContentType.BRAND_LOOKBOOK:
      return 'LOOKBOOK'
    case ContentType.BROADCAST:
      return 'STAR/BROADCAST'
    default:
      return contentType.toUpperCase()
  }
}

// NEWS는 li.list에 .news 클래스명 추가, 무료체험은 .free_trial추가, SALE은 .sale_info추가, EVENT는 .event추가, 레시피는 .food_recipe추가, 요리정보는 .cooking_info추가
// 참고 URL: http://view.ui.naver.com/shop/shoppingw/develop/view/front/common_store_content.php
export const getContentTypesIconClassName = (contentType: ContentType): string => {
  switch (contentType) {
    case ContentType.NEWS:
    case ContentType.BRAND_NEWS:
    case ContentType.PET_NEWS:
    case ContentType.FOOD_NEWS:
      return 'news'
    case ContentType.SALE_INFO:
    case ContentType.PET_SALE_INFO:
    case ContentType.FOOD_SALE_INFO:
      return 'sale_info'
    case ContentType.BRAND_EVENT:
      return 'event'
    default:
      return contentType ? contentType.toLowerCase() : 'none'
  }
}

export const getContentTypes = (subVertical: SubVertical): ContentType[] => {
  return typesUsedInSubVertical[subVertical] && typesUsedInSubVertical[subVertical].contentTypes
}
